import homeTab from './homeTab';
import notFoundTab from './notFoundTab';

export default [homeTab, notFoundTab];
